import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {reduceOperator, shaderDefinition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/reduction-helper-hal"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            operator: reduceOperator,
            custom: z.optional(
                z.object({
                    reduce: shaderDefinition,
                    preProcess: z.optional(shaderDefinition),
                    postProcess: z.optional(shaderDefinition),
                }),
            ),
            options: z.optional(
                z.object({
                    patchFillAddressMode: z._default(AddressMode, "border"),
                }),
            ),
        }),
    },
}
